if ($('.ordering-process').length) {
  $('.header-top .search').after('<div class="topNavContact"><div class="top-navigation-contacts">' + $('.top-navigation-contacts').html() + '</div></div>');
  function newFooter() {

    if ($('.id--16').length) {
      var textTop = $('#shipping-4 .shipping-billing-name').text().split(' - ')[0]
      var bottomText = $('#shipping-4 .shipping-billing-name').text().split(' - ')[1]
      $('#shipping-4 .shipping-billing-name').html('<span class="topText">'+textTop+'</span>');
      $('#shipping-4 .payment-info').append('<span class="bottomText">'+bottomText+'</span>');
      $('#shipping-4 .payment-info').append('<div class="mapLink"><span class="dataMap" data-href="https://maps.app.goo.gl/5kcdCaprgsedJd8u5" target="_blank">'+translation('zobrazitnamape')+'</span></div>')
      $('.shipping-billing-table .shipping-billing-name').each(function () {
        const $name = $(this);
        const text = $name.text().trim();

        if (text.includes('-')) {
            const parts = text.split('-');
            const mainText = parts.shift().trim();
            const textAfterDash = parts.join('-').trim();

            $name.text(mainText);

            $name.closest('label')
                .find('.payment-info')
                .append('<div class="shippingBillingNote">' + textAfterDash + '</div>');
        }
    });
      
      $('html').on('click', '.mapLink span', function(){
        window.open($(this).attr('data-href'), '_blank');
      })
      $('#order-shipping-methods').before('<p class="customPopupPrices"><span class="whyPrices">'+translation('procmameceny')+'</span></p>')
      $('html').on('click', '.whyPrices', function(){
        $.colorbox({
          html: $('footer#footer .deliveryInfo').closest('span').html(),
          width: 700,
          maxWidth: '90%',
          onClosed: function () {
           
          }
        });
      })
      const maxDate = localStorage.getItem('maxDeliveryDate');

    if (!maxDate) return;

    $('.order-delivery-payment-form #order-shipping-methods div:not("#shipping-'+osobniId+'") .payment-shipping-price').each(function () {

        const $price = $(this);
     
        // prevence duplicity
        $price.find('.customDateDelivery').remove();
        
        $price.append(`
            <span class="customDateDelivery">
                ${translation('doruceniDo')} ${maxDate}
            </span>
        `);

        $price.closest('label').find('.payment-info').append(`
            <span class="customDateDelivery">
                ${translation('doruceniDo')} ${maxDate}
            </span>
        `);
    });
    $('.order-delivery-payment-form #order-shipping-methods div#shipping-'+osobniId+' .payment-shipping-price').append('<span class="personalPickupAvailability"></span>')
    $('.order-delivery-payment-form #order-shipping-methods div#shipping-'+osobniId+' .payment-info').append('<span class="personalPickupAvailability"></span>')
     updatePersonalPickupStatus();
      
    }
    $('.responsive-tools').append($('footer#footer .heurekaHeader'));


    if ($('.id--9').length) {
    if($('.cart-empty').length){
        emptyCart();
        updateSupportStatus();
    }
    document.addEventListener('ShoptetDOMContentLoaded', function () {
        if($('.cart-empty').length){
         
           emptyCart();
           updateSupportStatus();
        }
    });
  }







    
    if ($(".id--15.in-dekujeme").length) {
      $('.recapitulation-wrapper[data-testid="recapTable"]').after(
        $("#footer .recenze.in-dekujeme").clone(),
      );
      $(".content-inner .in-dekujeme.recenze").after(
        `<div class='dekujeme_bnts'><a href="/" class='btn btn-default goBack'>${translation("zpetDoObchodu")}</a><div class='socials'></div></div>`,
      );
      $(".dekujeme_bnts .socials").append(
        $("#footer .fanAndCertifikate .fan").clone(),
      );
      $(".fan ul.fanList").append(
        $("footer#footer .contact-box span.facebook").closest("li").clone(),
        $("footer#footer .contact-box span.instagram").closest("li").clone(),
        $("footer#footer .contact-box span.youtube").closest("li").clone(),
        $("footer#footer .contact-box span.tiktok").closest("li").clone(),
      );
      $(".content-inner .dekujeme_bnts").after($("#footer .customBlog").clone());
      startBlog();
    }
    const storageKey = 'storeRatingData-' + document.location.host;
    const stored = sessionStorage.getItem(storageKey);

    if (stored) {
      let parsed = JSON.parse(stored);
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }
      const score = Math.round((parseFloat(parsed.averageScore) / 5) * 100);
      $('.heurekaHeader .customersPercentil').text(score + '%');
    }

  }


  $(document).ready(function () {
    loadFooter(newFooter);
    updateSupportStatus()
  });

}





if ($(".id--17").length) {
  $('input[name="vatId"]').removeAttr('placeholder')
  var $checkoutInputs = $(
    '.id--17 input[type="text"], .id--17 input[type="email"], .id--17 input[type="password"], .id--17 input[type="tel"]',
  );
  $checkoutInputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  $checkoutInputs.on("click focus", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  $checkoutInputs.on("blur", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $('.co-contact-information').prepend(`
            <div class="customLogin">
                    <p>${translation("mateUcet")}
                <span class="customLoginPopup">${translation("prihlasitSe")}</span></p>
        
            </div>
        `);

    $(".co-box-additional").after(`<div class="co-box reg">
                <h4>Ještě účet nemáte?</h4>
                <p>Můžete to napravit. Co na vás čeká?</p>
                <ul>
                    <li>Slevy až 80 % na vybrané produkty</li>
                    <li>Pravidelný newsletter</li>
                    <li>Historie objednávek</li>
                    <li>Objednávky na jednom místě</li>
                    <li>Speciální akce pouze pro registrované</li>
                </ul>
            </div>`);
    $(".co-box.reg").prepend($("#set-registration").closest(".form-group"));
  }
}

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));

  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());

  $.get(
    "/action/Cart/GetCartContent/?orderingProcessActive=1",
    function (data) {
      $('.cart-item[data-micro="cartItem"]').each(function () {
        get_id = $(this).attr("data-micro-sku");
        var $row = $(this);
        link = $(data.payload.content)
          .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image a')
          .attr("href");
        image = $(data.payload.content)
          .find(
            '.removeable[data-micro-sku="' + get_id + '"] .cart-p-image img',
          )
          .attr("data-src")
          .replace("related", "detail");
        if (!$(this).find(".right").length) {
          $(this).wrapInner('<div class="right"></div>');
          $(this).prepend(
            '<div class="image"><a href="' +
            link +
            '"><img src="' +
            image +
            '" alt="' +
            $(this).find('a[data-testid="recapItemName"]').text() +
            '"></a></div>',
          );
        }
      });
    },
  );
}

if ($(".id--15").length) {
  

  document.addEventListener('UpsellBannersRendered', function() {
    $('.recapitulation-wrapper').prepend($('.up-banner-wrapper'));
  });
  $("h1").text(translation("objednavkaPrijata"));
  $("h1").after("<p>" + translation("dekujemeZaObjednavku") + "</p>");
  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith(translation("cisloObjednavky") + " ");

  $('.recapitulation-wrapper[data-testid="recapTable"]').append(
    '<div class="co-box co-extra"></div>',
  );
  $(".co-box.co-extra").append(
    $('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])'),
  );
  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);
    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");
      $row.append(
        '<td class="zdarma"><span>' + translation("zdarma") + "</span></td>",
      );
      $row.find("strong.for-free").text(translation("darekKobj"));
      console.log("true");
    }
    const $cell = $row.find("td.p-quantity");
    if (!$cell.length) return;

    const total = parseFloat(
      $cell
        .find("strong")
        .text()
        .replace(/\s/g, "")
        .replace("Kč", "")
        .replace(",", "."),
    );
    $row.append(`<td class="pricePerSingle"><span>${total} / ks</span></td>`);
  });
}

if ($(".id--16").length) {
  $("#orderFormButton span").text(translation("continueToOrder"));
  $(document).on("click", "#checkoutSidebar h2.h4", function () {
    $(this).closest(".order-summary-inner").toggleClass("open");
  });
}

function mhProductInfoMove() {
  if ($(".id--9").length) {
    if ($(".extra.delivery span .price-range").length) {
      $(".extra.delivery").append(
        $(".extra.delivery span .price-range").clone(),
      );
    }
    let maxDeliveryDate = null;


    
if($('.free-gift').length){
  $('.cart-content table.cart-table').after($('.free-gift'))
}

$("tr.removeable").each(function () {

  $(this).find(".p-name").append($(this).find(".p-availability").clone());
  $(this).find(".p-total").append($(this).find(".p-price").clone());

  if ($(this).find('.p-name a.show-related').length) {
    $(this).find('.p-name .show-related').text(translation('nepotrebujeteNeco'));
  }

  $(this).find('.availability-amount').each(function () {

    const $amount = $(this);
    const availabilityText = $amount.text().replace('(', '').replace(')', '').replace('>', '> ');
    $amount.text(availabilityText + ',');

    $amount.attr('style', $(this).prev('.availability-label').attr('style'));

    const availabilityCartText = $(this).prev('.availability-label').text().trim().toLowerCase();

    const deliveryCartDate = getDeliveryDateByAvailability(availabilityCartText);

    if (!deliveryCartDate) return;

    // 👉 uložíme nejvyšší datum
    if (!maxDeliveryDate || deliveryCartDate > maxDeliveryDate) {
        maxDeliveryDate = deliveryCartDate;
    }

    const formattedCartDate = formatDeliveryDate(deliveryCartDate);

    $(this).after(
      `<div class="deliveryDate" style="${$(this).prev('.availability-label').attr('style')}">${formattedCartDate}</div>`
    );

  });

});


// 👉 po dokončení loopu uložíme datum
if (maxDeliveryDate) {

    const formattedMaxDate =
        maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";

    localStorage.setItem('maxDeliveryDate', formattedMaxDate);

    console.log('Max delivery date:', formattedMaxDate);
}

    if ($(".free-gift").length) {
      $(".free-product-gifts li").each(function () {
        $(this)
          .find(".free-gift-label")
          .prepend(
            `<span class="extraText">${translation("darekKobj")}</span>`,
          );
        $(this)
          .find(".free-gift-label")
          .append(`<span class="zdarma">${translation("zdarma")}</span>`);
      });
    }

    if ($(".related").length) {
      $(".related .cart-related-product").each(function () {
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-availability"));
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-name"));
        if ($(this).find('button[type="submit"]').length) {
          $(this).find('button[type="submit"]').text(translation('koupit'));
        }
      });
    }

    $(".summary-wrapper").after($(".next-step-back"));

    $(".summary-wrapper").prepend('<div class="customBox"></div>');

    $(".customBox").append(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                Mám slevový kód
            </label>
        `);

    $("#continue-order-button span").text(translation("continueToOrder"));
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $('.cart-table').prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">${translation("produktKosik")}</th>
                <th class="avail">${translation("dostupnost")}</th>
                <th class="qty">${translation("pocet")}</th>
                <th class="unit">${translation("cenaZaKus")}</th>
                <th class="sale">${translation("sleva")}</th>
                <th class="total">${translation("celkem")}</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $('tr.removeable').each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find('.p-price .show-tooltip').attr('title') || $row.find('.p-price .show-tooltip').attr('data-original-title');
          console.log()
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(',', '.'))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, '')) : 0;
          const finalPrice = parseInt(
            $row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, '')
          );
          const quantity = parseInt($row.find('input.amount').val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find('.p-price').append(`
                    <span class="sale-percent">${percent}%</span>
                `)
          $row.find('.p-total').before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      }
      else {
        $row.find('.p-total').before('<td class="p-sale"></td>');
      }




    });

    if (totalSaved > 0) {
      $('.price-wrapper').append(`
            <span class="price-label price-secondary" style="color:#118819;">
            ${translation('usetrili')}:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }


  } else {
    $('.cart-table').prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">${translation("produktKosik")}</th>
                <th class="avail">${translation("dostupnost")}</th>
                <th class="qty">${translation("pocet")}</th>
                <th class="unit">${translation("cenaZaKus")}</th>
                <th class="total">${translation("celkem")}</th>
            </tr>
        </thead>
    `);
  }



  $(".summary-wrapper .customBox").append(
    $(".cart-summary .discount-coupon").clone(),
  );
  $(".summary-wrapper .customBox").append(
    $(".cart-summary .extra.delivery").clone(),
  );

  $("#discount-checkbox").on("change", function () {
    $(".discount-coupon").toggleClass("active", this.checked);
  });

  if ($(".delivery-time").length) {
    $(".customBox").append($(".delivery-time"));
  }
  if ($('.discount-coupon .applied-coupon').length) {
    $('.discount-coupon').addClass('active')
    $('#discount-checkbox').prop('checked', true);
    $('input[data-testid="buttonRemoveDiscountCoupon"]').attr('value', translation('odebratKupon'))
  }
}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  mhProductInfoMove();
});

function startBlog() {
  const $blog = $(".customBlog");
  if (!$blog.length) return;

  const $blogSidebar = $blog.find(".blogSidebar");
  const $blogMain = $blog.find(".blogMain");

  /**
   * Univerzální loader sekce
   */
  function loadSection(storageKey, url, $target, afterLoad) {
    const cached = sessionStorage.getItem(storageKey);

    if (cached) {
      $target.append(cached);
      afterLoad && afterLoad();
      return;
    }

    $.ajax({
      type: "GET",
      dataType: "html",
      timeout: 10000,
      cache: true,
      url: url,
      success: function (html) {
        const doc = shoptet.common.createDocumentFromString(html);
        const content = $(doc).find("#newsWrapper").html();
        if (!content) return;

        $target.append(content);
        afterLoad && afterLoad();

        // uložíme do storage (bez h4 – řeší se níže)
        sessionStorage.setItem(storageKey, $target.html());
      },
    });
  }

  /**
   * Postprocessing obsahu
   */
  function mh_remove() {
    /* ===== MAIN ===== */
    $blogMain.find(".news-item").slice(2).remove();

    $blogMain.find(".news-item").each(function () {
      const $item = $(this);

      const $img = $item.find("img");
      if ($img.data("src")) {
        $img.attr("src", $img.data("src"));
      }

      if (!$item.find(".readMore").length) {
        const link = $item.find(".title").attr("href");
        $item.find(".text .description").after(
          `<div class="readBottom"><p class="readMore">
              <a href="${link}" class="btn btn-secondary">Celý článek</a>
            </p></div>`,
        );
      }
    });

    /* ===== SIDEBAR ===== */
    $blogSidebar.find(".news-item").slice(5).remove();

    $blogSidebar.find(".news-item").each(function () {
      const $img = $(this).find("img");
      if ($img.data("src")) {
        $img.attr("src", $img.data("src"));
      }
    });
  }

  /* ===== SIDEBAR ===== */
  loadSection(
    "blogSidebar",
    "/vybirame-pro-vas-to-nejzajimavejsi/",
    $blogSidebar,
    function () {
      mh_remove();
      loadReadingTimes($blogSidebar);
      // ❗ Uložíme kopii sidebaru BEZ h4
      const sidebarForStorage = $blogSidebar
        .clone()
        .find("h4")
        .remove()
        .end()
        .html();

      sessionStorage.setItem("blogSidebar", sidebarForStorage);
    },
  );

  /* ===== MAIN ===== */
  loadSection("blogMain", "/blog/", $blogMain, function () {
    mh_remove();
    loadReadingTimes($blogMain);
  });
}

////if($('.i--9').length){
  $('html').on('click', '.remove-item', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation()
    const $form = $(this);
    const itemId = $form.closest('form').find('input[name="itemId"]').attr('value');
    openRemoveConfirm($form, itemId);
  });
//}

$('html').on('click', '.id--9 .cart-table .quantity .decrease', function (e) {
    const $button = $(this);
    const $form = $button.closest('form');
    const $amount = $form.find('input[name="amount"]');
    const amount = parseInt($amount.val(), 10) || 0;

    if (amount <= 1) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const itemId = $form.find('input[name="itemId"]').val();

        openRemoveConfirm($button, itemId);
    }
});

$('html').on('click', '.cart-widget-product .quantity .decrease', function (e) {
    const $button = $(this);
    const $form = $button.closest('form');
    const $amount = $form.find('input[name="amount"]');
    const amount = parseInt($amount.val(), 10) || 0;

    if (amount <= 1) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const itemId = $form.find('input[name="itemId"]').val();

        openRemoveConfirm($button, itemId);
    }
});


function openRemoveConfirm($form, itemId) {

  $.colorbox({
    html: `
            <div class="cartRemoveConfirm">
                <p>${translation('opravduOdstranit')}</p>

                <div class="buttons">
                    <button class="btn btn-alert confirmRemove" data-id="${itemId}">
                        ${translation('odebrat')}
                    </button>
                    <button class="btn btn-conversion cancelRemove">
                        ${translation('ponechat')}
                    </button>
                </div>
            </div>
        `,
    width: 310,
    maxWidth: '90%',
    className: 'customRemoveCart',
    onClosed: function () {
      $('#colorbox').removeClass('customRemoveCart');
    }
  })
}

$(document).on('click', '.confirmRemove', function () {
  const itemId = $(this).attr('data-id');
  if (typeof shoptet !== 'undefined' && shoptet.cartShared) {
    shoptet.cartShared.removeFromCart({ itemId: itemId });
  }
  $.colorbox.close();
});




$(document).on('click', '.cancelRemove', function () {
  $.colorbox.close();
});







document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {
    $('#colorbox #cboxContent').attr('style', 'background-color:transparent;border:0;');
});

function emptyCart(){
      $('body').addClass('cartemptycustom');
      $("h1:not(.sr-only), .h1:not(.sr-only)").after($("#footer .emptyCartText"));
      $("h1:not(.sr-only), .h1:not(.sr-only)").text(translation("prazdnyKosik"));
      $(".cart-empty .emptyCartText").after(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
   
      `
      );
      $('.cart-empty .contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
      $('.cart-empty .contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
      $('.cart-empty .contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
      //$('.cart-empty .contactUs .left').append($('footer#footer .helpFooter .online').clone());
      $('.cart-empty .contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
      $('.cart-empty .contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
      $(".cart-empty .contactUs .right").append("<ul></ul>");
      $(".cart-empty .contactUs .right ul").append(
        $("footer#footer .contact-box span.tel").closest("li").clone(),
        $("footer#footer .contact-box span.mail").closest("li").clone(),
      );

    
}

$('html').on('click', '.customLoginPopup', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('body').addClass('user-action-visible login-window-visible');
});


$(function () {

  var invoiceFields = ['billStreet', 'billHouseNumber', 'billCity', 'billZip', 'billCountryId'];
  var storageKey = 'selected-shipping-id-' + window.location.hostname.replace(/^www\./, '');
  var $body = $('body');
  var $billing = $('.co-billing-address');
  var $contact = $('.co-contact-information');

  function getStoredShippingId() {
    var val = localStorage.getItem(storageKey);
    return val ? parseInt(val) : null;
  }

  function disableInvoiceValidation() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');
        $input.closest('.form-group').removeClass('js-validated-element-wrapper')
      $input.removeAttr('required')
            .removeClass('required js-validate js-validate-required');

      var originalText = $label.text().replace('*', '').trim();
      $label.text(originalText);
    });
  }

  function highlightRequiredFields() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');
      $label.html('<span class="required-asterisk">' + $label.text() + '</span>');
      $input.addClass('js-validate js-validate-required');
      $input.prop('required', true)
    });
  }

  function insertInvoiceCheckbox() {
    var html = `
      <div class="form-group" style="display:block!important;">
        <input type="checkbox" id="toggle-invoice">
        <label for="toggle-invoice" class="whole-width">Chci zadat fakturační adresu</label>
      </div>
    `;
    $contact.append(html);
  }

  function bindCheckboxToggle() {
    $(document).on('change', '#toggle-invoice', function () {
      if ($(this).is(':checked')) {
        $billing.addClass('visible');
        highlightRequiredFields();
        $.each(invoiceFields, function (i, fieldId) {
          $('#' + fieldId).attr('required', true);
        });
      } else {
        $billing.removeClass('visible');
        disableInvoiceValidation();
      }
    });
  }

  // Uložení zvolené dopravy v kroku 1
  if ($body.hasClass('id--16')) {
    $(document).on('click', '#orderFormButton', function () {
      var selectedId = $('[name="shippingId"]:checked').val();
      if (selectedId) {
        localStorage.setItem(storageKey, selectedId);
      }
    });
  }

  // Skrytí fakturační adresy v kroku 2 podle dopravy
  if ($body.hasClass('id--17')) {
    highlightRequiredFields(); // Výchozí stav

    var shippingId = getStoredShippingId();
    if ($.inArray(shippingId, allowedShippingIds) > -1) {
       $('.co-billing-address label[for="another-shipping"]').hide();
      disableInvoiceValidation();
      $billing.addClass('js-hidden');
      insertInvoiceCheckbox();
      bindCheckboxToggle();
     
    }
    else{
        
    }
  }
});

if ($('.id--17').length) {
const konfigurace = VypisKonfiguraceZKosiku();

if (konfigurace) {
    $('.co-contact-information').append(
        '<div class="form-group hide customField">' +
            '<label for="order_additional_field_02_name">Konfigurace</label>' +
            '<input name="varchar2" type="text" value="" id="order_additional_field_02_name" class="form-control">' +
        '</div>'
    );

    $('input[name="varchar2"]').val(konfigurace);
}
 /*
 shoptet.scripts.setCustomFunction("postSuccessfulValidation",function(form, args) {
            if ($(form).attr("id") === "order-form") {
                UlozitPoznamku();
            }
            return true;
        }
    );*/
}

if($('.id--15').length){
  localStorage.removeItem("productAddons");
}




function getCartState() {
    const cart = {};

    $('#summary-box .cart-item').each(function () {
        const sku = $(this).data('micro-sku');
        const amount = parseInt($(this).find('.cart-item-amount').text()) || 0;

        if (!sku) return;

        cart[sku] = (cart[sku] || 0) + amount;
    });

    return cart;
}

function filterStorageByCart(store, cartState) {
    const filtered = [];

    store.forEach(item => {
        if (!cartState[item.baseProductCode]) return;

        let validAddons = [];

        (item.addons || []).forEach(addon => {

            if (cartState[addon.sku]) {
                validAddons.push(addon);
            }

        });

        filtered.push({
            ...item,
            addons: validAddons
        });
    });

    return filtered;
}

function UlozitPoznamku() {

    const storeStr = localStorage.getItem('productAddons');
    if (!storeStr) return;

    let store = JSON.parse(storeStr);
    if (!store || !store.length) return;

    // 🔥 načti reálný košík
    const cartState = getCartState();

    // 🔥 filtr
    store = filterStorageByCart(store, cartState);

    if (!store.length) return;

    let noteText = '';

    const grouped = {};

    store.forEach(item => {

        if (!item.baseProductCode) return;

        if (!grouped[item.baseProductCode]) {
            grouped[item.baseProductCode] = [];
        }

        grouped[item.baseProductCode].push(item);
    });

    Object.entries(grouped).forEach(([sku, items]) => {

        noteText += "==================================\n";
        noteText += "Produkt: " + sku + "\n";
        noteText += "Počet konfigurací: " + items.length + "\n";
        noteText += "==================================\n\n";

        items.forEach((item, index) => {

            noteText += "Konfigurace #" + (index + 1) + ":\n";

            const extrasCount = {};

            (item.addons || []).forEach(extra => {
                extrasCount[extra.sku] =
                    (extrasCount[extra.sku] || 0) + (extra.amount || 1);
            });

            if (!Object.keys(extrasCount).length) {
                noteText += "- bez příplatků\n";
            } else {
                Object.entries(extrasCount).forEach(([sku, amount]) => {
                    noteText += "- " + amount + "× " + sku + "\n";
                });
            }

            noteText += "\n";
        });

        noteText += "\n";
    });

    if (!noteText.trim()) return;

    const $remark = $("textarea#remark");
    if (!$remark.length) return;

    let currentText = $remark.val() || '';

    currentText = currentText.replace(
        /### Konfigurace ###[\s\S]*?### Konfigurace ###/g,
        ''
    ).trim();

    const finalBlock =
        "### Konfigurace ###\n\n" +
        noteText.trim() +
        "\n\n### Konfigurace ###";

    if (currentText.length) currentText += "\n\n";

    $remark.val(currentText + finalBlock);
}

if ($('.id--16').length) {


  
  $(document).ready(function(){
    if($('#HcCalculater').length){
      $('div[data-id="billing-300"] .payment-info').append('<div class="hcinfo"><a class="hclink" href="'+$('#HcCalculater a').attr('href')+'">'+translation('spocitatSplatky')+'</a><p><a href="'+$('#HcCalculater+div>a').attr('href')+'">'+$('#HcCalculater+div>a').text()+'</a></p></div>');
    }
  });
 
 
  //if($('.radio-wrapper[data-id="billing-'+idHomecredit+'"]').length){

  //}

  if ($('#shipping-'+pplWidgetId).length) {
    $(document).on("click", ".sublabel[data-method-id='"+pplWidgetId+"']", function(e) {
      e.preventDefault();
      var $label = $(e.currentTarget); // konkrétní sublabel, ne všechny

      $.colorbox({
        html: '<div id="ppl-parcelshop-map" style="width:100%; height:100%;" data-country="cz" data-countries="cz, sk" data-language="cs" data-mode="default"></div>',
        width: "90%",
        height: "90%",
        onComplete: function() {
          document.addEventListener("ppl-parcelshop-map", function(event) {
            var branch = event.detail;
            console.log(branch);

            var point = {
              pointID: String(branch.id),
              pointCode: String(branch.code),
              pointName: branch.name,
              pointStreet: branch.street,
              pointCity: branch.city,
              pointZIP: branch.zipCode,
              pointCountry: branch.country
            };

            // uložit do sessionStorage
            sessionStorage.setItem("pplBranch", JSON.stringify([point]));

            // zjistit methodId z kliknutého labelu
            var methodId = $label.data('method-id');

            // vyplnit hidden input
            $('#shipping-' + methodId + '-pickupPointId-selected').val(point.pointCode);

            // vypsat adresu do labelu
            $label.html('<a href="#" class="chosen">'+point.pointCity + ', ' + point.pointStreet +' <span class="changePPL">Změnit</span></a>');

            $.colorbox.close();
          }, { once: true });

          var link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = "https://www.ppl.cz/sources/map/main.css";
          document.head.appendChild(link);

          var script = document.createElement("script");
          script.src = "https://www.ppl.cz/sources/map/main.js";
          document.head.appendChild(script);
        }
      });
    });
  }
}

/*
function VypisKonfiguraceZKosiku() {
    const storeStr = localStorage.getItem('productAddons');

    if (!storeStr) {
        console.log('productAddons není v localStorage.');
        return '';
    }

    let store;

    try {
        store = JSON.parse(storeStr);
    } catch (e) {
        console.error('productAddons není validní JSON', e);
        return '';
    }

    if (!Array.isArray(store) || !store.length) {
        console.log('productAddons je prázdný.');
        return '';
    }

    const cartState = {};

    $('#summary-box .cart-item').each(function () {
        const sku = String($(this).data('micro-sku'));
        const amount = parseInt($(this).find('.cart-item-amount').text(), 10) || 0;

        if (!sku) return;

        cartState[sku] = (cartState[sku] || 0) + amount;
    });

    const output = [];

    store.forEach(item => {
        const baseProductCode = String(item.baseProductCode);

        // Základní produkt musí být reálně v košíku
        if (!cartState[baseProductCode]) return;

        const addonsText = [];

        (item.addons || []).forEach(addon => {
            const addonSku = String(addon.sku);

            // Addon musí být reálně v košíku
            if (!cartState[addonSku]) return;

            const addonAmount = addon.amount || 1;

            addonsText.push(addonAmount + '× ' + addonSku);
        });

        // Pokud nejsou žádné reálné příplatky, tento produkt do konfigurace nedávat
        if (!addonsText.length) return;

        output.push(baseProductCode + ' - ' + addonsText.join(', '));
    });

    const result = output.join('; ');

    console.log(result);

    return result;
}*/
/*
if ($('body.admin-logged').length) {

    var pplWidgetId = typeof pplWidgetId !== 'undefined' ? pplWidgetId : null;
    var pplWidgetApiKey = 'ak_ce7853d3d1da4503b38c07c4473e792d';

    var pplWidgetInitialized = false;
    var pplWidgetAssetsLoading = false;
    var pplWidgetAssetsLoaded = false;

    function initPplWidgetForShoptet() {
        if (pplWidgetInitialized) {
            return;
        }

        if (!pplWidgetId) {
            return;
        }

        if (!$('#shipping-' + pplWidgetId).length) {
            return;
        }

        pplWidgetInitialized = true;

        createPplWidgetStaticModal();
        bindPplWidgetOpen();
        bindPplWidgetSelect();
        restorePplSelectedBranch();
        loadPplWidgetAssets();
    }

    function createPplWidgetStaticModal() {
        if ($('#pplWidget').length) {
            return;
        }

        $('body').append(`
            <ppl-access-point-widget
                id="pplWidget"
                api-key="${pplWidgetApiKey}"
                config='{"viewMode":"modal"}'>
            </ppl-access-point-widget>

            <button type="button" id="pplWidgetButton" style="display:none;">
                Vybrat výdejní místo
            </button>
        `);

        $('#pplWidgetButton')
            .off('click.pplWidgetButton')
            .on('click.pplWidgetButton', function () {
                var widget = document.getElementById('pplWidget');

                if (!widget || typeof widget.open !== 'function') {
                    alert('Mapa výdejních míst se ještě načítá. Zkuste to prosím za chvíli.');
                    return;
                }

                widget.open();
            });
    }

    function loadPplWidgetAssets() {
        if (pplWidgetAssetsLoaded || pplWidgetAssetsLoading) {
            return;
        }

        if ($('script[data-ppl-widget-loader]').length) {
            pplWidgetAssetsLoaded = true;
            return;
        }

        pplWidgetAssetsLoading = true;

        var script = document.createElement('script');
        script.src = 'https://www.ppl.cz/accesspointwidget/loader.js';
        script.async = true;
        script.setAttribute('data-ppl-widget-loader', 'true');

        script.onload = function () {
            pplWidgetAssetsLoaded = true;
            pplWidgetAssetsLoading = false;
        };

        script.onerror = function () {
            pplWidgetAssetsLoading = false;
            pplWidgetInitialized = false;
            console.warn('Nepodařilo se načíst PPL widget loader.');
        };

        document.head.appendChild(script);
    }

    function bindPplWidgetOpen() {
        $(document)
            .off('click.pplWidgetOpen', ".sublabel[data-method-id='" + pplWidgetId + "']")
            .on('click.pplWidgetOpen', ".sublabel[data-method-id='" + pplWidgetId + "']", function (e) {
                e.preventDefault();

                var methodId = $(e.currentTarget).data('method-id');

                sessionStorage.setItem('pplCurrentMethodId', methodId);

                openPplWidgetByButton();
            });

        $(document)
            .off('click.pplWidgetChange', '.changePPL')
            .on('click.pplWidgetChange', '.changePPL', function (e) {
                e.preventDefault();
                e.stopPropagation();

                sessionStorage.setItem('pplCurrentMethodId', pplWidgetId);

                openPplWidgetByButton();
            });
    }

    function openPplWidgetByButton() {
        var $button = $('#pplWidgetButton');

        if (!$button.length) {
            createPplWidgetStaticModal();
            $button = $('#pplWidgetButton');
        }

        $button.trigger('click');
    }

    function bindPplWidgetSelect() {
        document.removeEventListener('ppl-accesspointwidget-select', handlePplWidgetSelect);
        document.addEventListener('ppl-accesspointwidget-select', handlePplWidgetSelect);
    }

    function handlePplWidgetSelect(event) {
        var branch = event.detail;

        if (!branch) {
            return;
        }

        var methodId = sessionStorage.getItem('pplCurrentMethodId') || pplWidgetId;
        var point = normalizePplBranch(branch);

        if (!point.pointCode) {
            console.warn('PPL widget nevrátil KM kód výdejního místa.', branch);
            return;
        }

        sessionStorage.setItem('pplBranch', JSON.stringify([point]));

        $('#shipping-' + methodId + '-pickupPointId-selected').val(point.pointCode);

        renderPplSelectedBranch(methodId, point);
    }

    function normalizePplBranch(branch) {
        var address = branch.address || {};

        return {
            pointID: String(branch.id || branch.accessPointId || ''),
            pointCode: String(branch.code || branch.accessPointCode || ''),
            pointName: branch.name || branch.accessPointName || '',
            pointStreet: branch.street || address.street || '',
            pointCity: branch.city || address.city || '',
            pointZIP: branch.zipCode || branch.zip || address.zipCode || '',
            pointCountry: branch.country || address.country || ''
        };
    }

    function renderPplSelectedBranch(methodId, point) {
        var $label = $(".sublabel[data-method-id='" + methodId + "']");

        if (!$label.length) {
            return;
        }

        $label.html(`
            <a href="#" class="chosen">
                ${point.pointCity}, ${point.pointStreet}
                <span class="changePPL">Změnit</span>
            </a>
        `);
    }

    function restorePplSelectedBranch() {
        var storedBranch = sessionStorage.getItem('pplBranch');

        if (!storedBranch) {
            return;
        }

        try {
            var points = JSON.parse(storedBranch);
            var point = points && points[0];

            if (!point || !point.pointCode) {
                return;
            }

            $('#shipping-' + pplWidgetId + '-pickupPointId-selected').val(point.pointCode);
            renderPplSelectedBranch(pplWidgetId, point);
        } catch (e) {
            sessionStorage.removeItem('pplBranch');
        }
    }

    $(document).ready(function () {
        initPplWidgetForShoptet();
    });

    document.addEventListener('ShoptetDOMContentLoaded', function () {
        initPplWidgetForShoptet();
    });

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        initPplWidgetForShoptet();
    });

}*/

/*
 * ============================================================
 * UPSELL - ZACHYCENÍ PŘIDÁNÍ ADDONU
 * ============================================================
 */

document.addEventListener('UpsellAddonAddedToCart', function (event) {

    if (!event.detail) return;

    const items = Array.isArray(event.detail)
        ? event.detail
        : [event.detail];

    let store = [];

    try {
        store = JSON.parse(
            localStorage.getItem('upsellAddons')
        ) || [];
    } catch (e) {
        store = [];
    }

    items.forEach(function (item) {

        if (!item.code || !item.parentProductCode) {
            return;
        }

        const addonSku = String(item.code).trim();
        const parentSku = String(item.parentProductCode).trim();
        const amount = parseInt(item.amount, 10) || 1;

        const existing = store.find(function (x) {
            return (
                String(x.parentProductCode) === parentSku &&
                String(x.sku) === addonSku
            );
        });

        if (existing) {

            existing.amount = amount;
            existing.offerId =
                item.offerId || existing.offerId || null;

        } else {

            store.push({
                parentProductCode: parentSku,
                sku: addonSku,
                amount: amount,
                offerId: item.offerId || null
            });

        }

    });

    localStorage.setItem(
        'upsellAddons',
        JSON.stringify(store)
    );

    console.log(
        '[Upsell EVENT] Uložené vazby:',
        store
    );

});



/*
 * ============================================================
 * NAČTENÍ / REKONSTRUKCE UPSELL VAZEB Z KOŠÍKU
 * ============================================================
 */

function NactiUpsellVazbyZKosiku() {

    let store = [];

    try {
        store = JSON.parse(
            localStorage.getItem('upsellAddons')
        ) || [];
    } catch (e) {
        store = [];
    }


    /*
     * --------------------------------------------------------
     * Najdeme Upsell vazby přímo v HTML
     *
     * data-offer-sku = kmenový produkt
     * data-code      = addon
     * data-offer     = offer ID
     * --------------------------------------------------------
     */

    $('[data-offer-sku][data-code]').each(function () {

        const $el = $(this);

        const parentSku = String(
            $el.attr('data-offer-sku') || ''
        ).trim();

        const addonSku = String(
            $el.attr('data-code') || ''
        ).trim();

        const offerId =
            $el.attr('data-offer') || null;


        if (!parentSku || !addonSku) {
            return;
        }


        /*
         * Kmenový produkt musí být v košíku
         */

        const $parentRow = $(
            'tr[data-micro-sku="' + parentSku + '"]'
        ).first();

        if (!$parentRow.length) {
            return;
        }


        /*
         * Addon musí být skutečně v košíku
         */

        const $addonRow = $(
            'tr[data-micro-sku="' + addonSku + '"]'
        ).first();

        if (!$addonRow.length) {
            return;
        }


        /*
         * Množství addonu
         */

        let amount = parseInt(
            $addonRow
                .find('input[name="amount"]')
                .first()
                .val(),
            10
        ) || 1;


        /*
         * Existuje už vazba?
         */

        const existing = store.find(function (item) {

            return (
                String(item.parentProductCode) === parentSku &&
                String(item.sku) === addonSku
            );

        });


        if (existing) {

            existing.amount = amount;

            if (offerId) {
                existing.offerId = offerId;
            }

        } else {

            store.push({
                parentProductCode: parentSku,
                sku: addonSku,
                amount: amount,
                offerId: offerId
            });

        }

    });



    /*
     * --------------------------------------------------------
     * Vyčistíme neplatné vazby.
     *
     * Parent i addon musí být stále v košíku.
     * --------------------------------------------------------
     */

    store = store.filter(function (item) {

        const parentSku =
            String(item.parentProductCode);

        const addonSku =
            String(item.sku);


        const parentExists = $(
            'tr[data-micro-sku="' + parentSku + '"]'
        ).length > 0;


        const addonExists = $(
            'tr[data-micro-sku="' + addonSku + '"]'
        ).length > 0;


        return parentExists && addonExists;

    });



    /*
     * --------------------------------------------------------
     * Uložíme vazby
     * --------------------------------------------------------
     */

    localStorage.setItem(
        'upsellAddons',
        JSON.stringify(store)
    );


    console.log(
        '[Upsell] Vazby z košíku:',
        store
    );



    /*
     * ========================================================
     * ULOŽENÍ POŘADÍ KMENOVÝCH PRODUKTŮ
     * ========================================================
     *
     * Procházíme skutečný košík shora dolů.
     *
     * Addony vynecháváme.
     * ========================================================
     */

    const cartOrder = [];


    $('tr[data-micro-sku]').each(function () {

        const $row = $(this);

        const sku = String(
            $row.attr('data-micro-sku') || ''
        ).trim();


        if (!sku) {
            return;
        }


        /*
         * Je tento řádek Upsell addon?
         *
         * Addon má v řádku:
         *
         * .remove-item.up-is-addon
         */

        const isAddon =
            $row.find('.up-is-addon').length > 0;


        if (isAddon) {

            console.log(
                '[Upsell] Přeskakuji addon v pořadí:',
                sku
            );

            return;
        }


        /*
         * Zabráníme duplicitám
         */

        if (!cartOrder.includes(sku)) {
            cartOrder.push(sku);
        }

    });


    /*
     * Uložíme skutečné pořadí kmenových produktů.
     */

    localStorage.setItem(
        'cartProductOrder',
        JSON.stringify(cartOrder)
    );


    console.log(
        '[Upsell] Pořadí kmenových produktů:',
        cartOrder
    );


    return store;
}



/*
 * ============================================================
 * VÝPIS KONFIGURACE
 * ============================================================
 */


function VypisKonfiguraceZKosiku() {

    let productAddons = [];
    let upsellAddons = [];
    let cartOrder = [];


    /*
     * ========================================================
     * AKTUÁLNÍ STAV KOŠÍKU NA CHECKOUTU
     * ========================================================
     */

    const cartState = {};


    $('.cart-items .cart-item[data-micro-sku]').each(function () {

        const $item = $(this);

        const sku = String(
            $item.attr('data-micro-sku') || ''
        ).trim();

        if (!sku) {
            return;
        }


        const amount = parseInt(
            $item.find('.cart-item-amount').text(),
            10
        ) || 1;


        cartState[sku] =
            (cartState[sku] || 0) + amount;

    });


    console.log(
        '[Konfigurace] AKTUÁLNÍ KOŠÍK:',
        cartState
    );



    /*
     * ========================================================
     * productAddons
     * ========================================================
     */

    try {

        productAddons = JSON.parse(
            localStorage.getItem('productAddons')
        ) || [];

    } catch (e) {

        console.error(
            '[Konfigurace] Chyba productAddons:',
            e
        );

        productAddons = [];
    }



    /*
     * ========================================================
     * upsellAddons
     * ========================================================
     */

    try {

        upsellAddons = JSON.parse(
            localStorage.getItem('upsellAddons')
        ) || [];

    } catch (e) {

        console.error(
            '[Konfigurace] Chyba upsellAddons:',
            e
        );

        upsellAddons = [];
    }



    /*
     * ========================================================
     * POŘADÍ KMENOVÝCH PRODUKTŮ
     * ========================================================
     */

    try {

        cartOrder = JSON.parse(
            localStorage.getItem('cartProductOrder')
        ) || [];

    } catch (e) {

        cartOrder = [];
    }



    /*
     * ========================================================
     * VAZBY
     * ========================================================
     */

    const relations = {};


    function addRelation(
        parentSku,
        addonSku,
        amount
    ) {

        parentSku = String(
            parentSku || ''
        ).trim();

        addonSku = String(
            addonSku || ''
        ).trim();


        if (!parentSku || !addonSku) {
            return;
        }


        /*
         * ----------------------------------------
         * DŮLEŽITÉ:
         *
         * Parent musí být TEĎ v košíku.
         * ----------------------------------------
         */

        if (!cartState[parentSku]) {

            console.log(
                '[Konfigurace] Parent není v košíku:',
                parentSku
            );

            return;
        }


        /*
         * ----------------------------------------
         * DŮLEŽITÉ:
         *
         * Addon musí být TEĎ v košíku.
         * ----------------------------------------
         */

        if (!cartState[addonSku]) {

            console.log(
                '[Konfigurace] Addon není v košíku:',
                addonSku,
                'parent:',
                parentSku
            );

            return;
        }


        if (!relations[parentSku]) {
            relations[parentSku] = [];
        }


        /*
         * Duplicitní vazba?
         */

        const existing = relations[parentSku].find(
            function (item) {
                return item.sku === addonSku;
            }
        );


        if (existing) {

            existing.amount =
                parseInt(amount, 10) || 1;

        } else {

            relations[parentSku].push({
                sku: addonSku,
                amount: parseInt(amount, 10) || 1
            });

        }

    }



    /*
     * ========================================================
     * PŮVODNÍ productAddons
     * ========================================================
     */

    if (Array.isArray(productAddons)) {

        productAddons.forEach(function (item) {

            if (!item.baseProductCode) {
                return;
            }


            (item.addons || []).forEach(
                function (addon) {

                    addRelation(
                        item.baseProductCode,
                        addon.sku,
                        addon.amount
                    );

                }
            );

        });

    }



    /*
     * ========================================================
     * UPSELL ADDONY
     * ========================================================
     */

    if (Array.isArray(upsellAddons)) {

        upsellAddons.forEach(function (item) {

            addRelation(
                item.parentProductCode,
                item.sku,
                item.amount
            );

        });

    }



    console.log(
        '[Konfigurace] PLATNÉ VAZBY:',
        relations
    );



    /*
     * ========================================================
     * VYČISTÍME POŘADÍ
     * ========================================================
     *
     * Ponecháme jen produkty, které jsou
     * skutečně v aktuálním košíku.
     * ========================================================
     */

    cartOrder = cartOrder.filter(function (sku) {

        return !!cartState[String(sku)];

    });



    /*
     * Pokud nějaký parent v cartOrder není,
     * ale má platnou konfiguraci, doplníme ho.
     */

    Object.keys(relations).forEach(
        function (parentSku) {

            if (!cartOrder.includes(parentSku)) {
                cartOrder.push(parentSku);
            }

        }
    );



    console.log(
        '[Konfigurace] POŘADÍ:',
        cartOrder
    );



    /*
     * ========================================================
     * FINÁLNÍ VÝSTUP
     * ========================================================
     */

    const output = [];


    cartOrder.forEach(function (parentSku) {

        if (!relations[parentSku]) {
            return;
        }


        const addonsText = [];


        relations[parentSku].forEach(
            function (addon) {

                /*
                 * Ještě jedna finální pojistka.
                 */

                if (!cartState[addon.sku]) {
                    return;
                }


                addonsText.push(
                    addon.amount +
                    '× ' +
                    addon.sku
                );

            }
        );


        if (!addonsText.length) {
            return;
        }


        output.push(
            parentSku +
            ' - ' +
            addonsText.join(', ')
        );

    });



    const result = output.join('; ');


    console.log(
        '[Konfigurace] VÝSLEDEK:',
        result
    );


    return result;
}

function goldHideCart() {
    var jeVyjmutKosik = vyjmuti.includes(
        parseInt(getShoptetDataLayer('customer')?.groupId || 0, 10)
    );

    if (jeVyjmutKosik) {
        $('.up-products-cart-table-wrapper').each(function () {
            var $wrapper = $(this);

            $wrapper.find('.up-products-cart .up-add-to-cart-cell a').each(function () {
                var sku = String($(this).attr('data-code'));

                if (vyjmutiSKUS.includes(sku)) {
                    $(this)
                        .closest('tr.up-product')
                        .attr('style', 'display:none!important;');
                }
            });

            var $available = $wrapper.find('tr.up-product').filter(function () {
                return this.style.display !== 'none';
            });

            $available.slice(0, 3).removeClass('as-hidden');
            var $moreButtonRow = $wrapper.find('.up-show-more-button-cell').closest('tr');

            if ($available.length <= 3) {
                $moreButtonRow.attr('style', 'display:none!important;');
            } else {
                $moreButtonRow.removeAttr('style');
            }

            if ($available.length === 0) {
                $wrapper.attr('style', 'display:none!important;');
            }
        });
    }
}

if ($('.id--9').length) {
    NactiUpsellVazbyZKosiku();
    goldHideCart();
    document.addEventListener('ShoptetDOMContentLoaded', function () {
        goldHideCart();
    });
    document.addEventListener('UpsellCartRendered', function () {
        goldHideCart();
    });
    $(document).on('click', '.up-more-link', function () {
        setTimeout(goldHideCart, 0);
    });

}